// Whether a selection fits, said in words. Pure.

import { WEB_UPLOAD_LIMITS } from "./config";

export interface SizedFile {
  name: string;
  /** As uploaded — after conversion to WAV. */
  uploadBytes: number;
}

function mb(bytes: number): string {
  return `${Math.round(bytes / (1024 * 1024))} MB`;
}

/** Null when it fits; otherwise the one sentence to show. */
export function limitProblem(files: SizedFile[], limits = WEB_UPLOAD_LIMITS): string | null {
  if (files.length === 0) return "Pick at least one file to upload.";
  const tooBig = files.filter((f) => f.uploadBytes > limits.maxFileBytes);
  if (tooBig.length === 1) {
    return `"${tooBig[0]!.name}" is ${mb(tooBig[0]!.uploadBytes)} as a WAV. Files can be up to ${mb(limits.maxFileBytes)}.`;
  }
  if (tooBig.length > 1) {
    return `${tooBig.length} files are over ${mb(limits.maxFileBytes)} as WAVs. Leave them out or export them shorter.`;
  }
  const total = files.reduce((n, f) => n + f.uploadBytes, 0);
  if (total > limits.maxUploadBytes) {
    return `That's ${mb(total)} in all. One upload can be up to ${mb(limits.maxUploadBytes)}. Untick a few tracks.`;
  }
  return null;
}
